import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import "@/i18n/i18n";
import App from "@/App";

const rootElement = document.getElementById("root");

const AppWithProviders = (
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// SEO SSR : the build/dev pipeline injects an answer-first block inside #root
// for crawlers, marked with data-seo-prerender="true" (real <h1> + content so
// Bing counts it, unlike a <noscript> block). That block must NEVER trigger
// React hydration — we treat #root as "empty" when its only element children
// are <noscript> nodes or the data-seo-prerender block, then strip and mount
// React cleanly. Only genuine pre-rendered React content (react-snap) hydrates.
const hasReactContent = Array.from(rootElement.childNodes).some(
  (node) =>
    node.nodeType === 1 &&
    node.tagName !== "NOSCRIPT" &&
    !node.hasAttribute("data-seo-prerender"),
);

if (hasReactContent) {
  ReactDOM.hydrateRoot(rootElement, AppWithProviders);
} else {
  // Strip the SEO noscript fallback so React starts from a clean root.
  rootElement.innerHTML = "";
  const root = ReactDOM.createRoot(rootElement);
  root.render(AppWithProviders);
}
